import React from 'react'


export default function H1P(props) {
    return(
        <div data-aos={props.H1PEffect} className={props.class} ref={props.refer}>
            <h1 id={props.id} className={props.titleClass}>{props.title}</h1>
            <h2>{props.title2}</h2>
            <p>{props.text}</p>
        </div>
    )
}